import React, { FC } from "react";
import { Row, Col } from "reactstrap";
import { AEAField } from "@components/";
import { ProaSummaryPresenter } from "@presenters/screens/proa-summary.presenter";

export interface IBaseDataProaProps {
  presenter: ProaSummaryPresenter;
}

const BaseDataProa: FC<any> = (props: IBaseDataProaProps) => {
  let hasPermission = props.presenter.getTotalPermissions()
  let planificationField = props.presenter.planificationField
  planificationField.readOnly = hasPermission ? false : true

  return (
    <>
      <Row xs="1" sm="2" md="2" lg="2" xl="2">
        <Col xs="12" sm="12" md="3" lg="3" xl="3">
          <AEAField {...planificationField}></AEAField>
        </Col>
        <Col xs="12" sm="12" md="9" lg="9" xl="9"></Col>
      </Row>
      <Row xs="1" sm="2" md="2" lg="2" xl="2">
        <Col>
          <AEAField {...props.presenter.projectCodeTextField}></AEAField>
        </Col>
        <Col>
          <AEAField {...props.presenter.countryField}></AEAField>
        </Col>
      </Row>
      <Row xs="1" sm="2" md="2" lg="2" xl="2">
        <Col>
          <AEAField {...props.presenter.titleField}></AEAField>
        </Col>
        <Col>
          <AEAField {...props.presenter.strategicObjetiveField}></AEAField>
        </Col>
      </Row>
      <Row xs="1" sm="2" md="2" lg="2" xl="2">
        <Col>
          <AEAField {...props.presenter.beginDateField}></AEAField>
        </Col>
        <Col>
          <AEAField {...props.presenter.endDateField}></AEAField>
        </Col>
      </Row>
      <Row xs="1" sm="2" md="2" lg="2" xl="2">
        <Col>
          {" "}
          <AEAField {...props.presenter.regionCountryField}></AEAField>
        </Col>
        <Col>
          <AEAField {...props.presenter.tagsListField}></AEAField>
        </Col>
      </Row>
      <Row xs="1" sm="2" md="2" lg="2" xl="2">
        <Col>
          <AEAField {...props.presenter.lineIntervencionField}></AEAField>
        </Col>
        <Col>
          <AEAField {...props.presenter.strategicLineField}></AEAField>
        </Col>
      </Row>
    </>
  );
};

export default BaseDataProa;
